import React from 'react';
import { useTranslation } from 'react-i18next';
import { PhoneFrame, LbTabs, DemoCaption } from './PhoneFrame';
import { AVATARS, CROWNS } from './assets';
import { STANDINGS } from './data';

const K = 'caseStudies.worldCup.standings';

// LeaderboardPodium order: silver on the start side, gold centre, bronze end.
const PODIUM = [
  { i: 1, cls: 'p2' },
  { i: 0, cls: 'p1' },
  { i: 2, cls: 'p3' },
];

// The main tab: LeaderboardPodium for the top 3, LeaderboardList below.
const StandingsWidget = ({ lang }) => {
  const { t } = useTranslation();
  return (
    <figure className="demo">
      <DemoCaption title={t(`${K}.title`)} note={t(`${K}.note`)} />
      <PhoneFrame lang={lang}>
        <div className="scr-body">
          <LbTabs active="main" />
          <div className="pod">
            {PODIUM.map(({ i, cls }) => {
              const r = STANDINGS[i];
              return (
                <div className={`pod-card ${cls}`} key={r.en}>
                  <div className="pod-av">
                    <img className="pod-crown" src={CROWNS[i]} alt="" />
                    <img className="av" src={AVATARS[r.avatar]} alt="" />
                  </div>
                  <div className="pod-name">{r[lang]}</div>
                  <div className="pod-pts">{r.pts}</div>
                </div>
              );
            })}
          </div>
          <div className="lbl">
            {STANDINGS.slice(3).map((r, k) => (
              <div className={`lbl-row${r.me ? ' me' : ''}`} key={r.en}>
                <span className="lbl-rank">{k + 4}</span>
                <img className="av" src={AVATARS[r.avatar]} alt="" />
                <span className="lbl-name">{r[lang]}</span>
                <span className="lbl-pts">{r.pts}</span>
              </div>
            ))}
          </div>
        </div>
      </PhoneFrame>
    </figure>
  );
};

export default StandingsWidget;
